export const LABEL_W = 460;
export const LABEL_H = 236;

export function parseMg(vialSize) {
  const m = /([\d.]+)\s*mg/i.exec(vialSize || "");
  return m ? Number(m[1]) : null;
}

export function doseUnits(peptideMg, bacMl, dose, unit) {
  const d = Number(dose);
  if (!peptideMg || !bacMl || !d) return null;
  const doseMg = unit === "mcg" ? d / 1000 : d;
  return Math.round((doseMg / (peptideMg / bacMl)) * 100 * 10) / 10;
}

export const fmtShort = (date) => date.toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "2-digit" });

function fitText(ctx, text, maxW, size, weight, min = 16) {
  let s = size;
  do {
    ctx.font = `${weight} ${s}px Outfit, Arial, sans-serif`;
    s -= 1;
  } while (ctx.measureText(text).width > maxW && s > min);
}

function drawLandscape(ctx, d) {
  const W = LABEL_W;
  const pad = 14;
  ctx.fillStyle = "#fff";
  ctx.fillRect(0, 0, W, LABEL_H);
  ctx.strokeStyle = "#000";
  ctx.lineWidth = 3;
  ctx.strokeRect(4, 4, W - 8, LABEL_H - 8);
  ctx.fillStyle = "#000";
  ctx.textBaseline = "top";

  fitText(ctx, d.strength, 140, 34, 700);
  const sw = ctx.measureText(d.strength).width;
  ctx.fillText(d.strength, W - pad - sw, pad + 6);
  fitText(ctx, d.peptide, W - pad * 3 - sw, 46, 700);
  ctx.fillText(d.peptide, pad, pad);

  fitText(ctx, d.client, W - pad * 2, 28, 500);
  ctx.fillText(d.client, pad, 68);

  ctx.fillRect(pad, 104, W - pad * 2, 2);

  if (d.mixLine) {
    fitText(ctx, d.mixLine, W - pad * 2, 26, 500);
    ctx.fillText(d.mixLine, pad, 114);
  }
  if (d.doseLine) {
    fitText(ctx, d.doseLine, W - pad * 2, 28, 700);
    ctx.fillText(d.doseLine, pad, 142);
  }
  const ruo = "FOR RESEARCH USE ONLY · NOT FOR HUMAN USE";
  fitText(ctx, ruo, W - pad * 2, 24, 800, 12);
  ctx.fillText(ruo, pad, 174);
  fitText(ctx, d.footer, W - pad * 2, 18, 600, 14);
  ctx.fillText(d.footer, pad, LABEL_H - pad - 18);
}

export function renderLabel(canvas, d, rotate) {
  canvas.width = rotate ? LABEL_H : LABEL_W;
  canvas.height = rotate ? LABEL_W : LABEL_H;
  const ctx = canvas.getContext("2d");
  ctx.save();
  if (rotate) {
    ctx.translate(LABEL_H, 0);
    ctx.rotate(Math.PI / 2);
  }
  drawLandscape(ctx, d);
  ctx.restore();
}
